import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {Q9HtmlDecoderPipe, Q9TrackDirective} from '@q9elements/ui-kit/common';
import {
  DialogCloseButtonComponent,
  GridFilterOperatorSelectComponent,
  GridModule,
  IconButtonComponent,
  InfoMessageComponent,
  NodeSearchComponent,
  NotificationsModule,
  PrimaryButtonComponent,
  ReportsModule,
  SecondaryButtonComponent,
  SectionComponent,
  SelectModule,
  SupportButtonComponent,
  TextFieldComponent,
  ThemeSwitcherComponent,
  BlurWrapperComponent,
  ToolbarModule
} from '@q9elements/ui-kit/components';
import {OrgNodeSidebarModule} from '@q9elements/ui-kit/refmodels';

import {InternalSidebarModule} from '../internal-sidebar/internal-sidebar.module';
import {SharedModule} from '../shared/shared.module';
import {SidebarWrapperModule} from '../sidebar/sidebar-wrapper.module';
import {CodeSearchComponent} from './code-search.component';
import {CodeSearchLoadingComponent} from './components/code-search-loading/code-search-loading.component';
import {CodeSearchNumericFilterComponent} from './components/code-search-numeric-filter/code-search-numeric-filter.component';
import {CodeSearchTextFilterComponent} from './components/code-search-text-filter/code-search-text-filter.component';
import {CodeSearchViewComponent} from './components/code-search-view/code-search-view.component';
import {RunCodeSearchDialogComponent} from './components/run-code-search-dialog/run-code-search-dialog.component';
import {RunToolbarCodeSearchDialogComponent} from './components/run-toolbar-code-search-dialog/run-toolbar-code-search-dialog.component';

@NgModule({
  declarations: [
    CodeSearchComponent,
    CodeSearchLoadingComponent,
    RunCodeSearchDialogComponent,
    CodeSearchViewComponent,
    CodeSearchTextFilterComponent,
    CodeSearchNumericFilterComponent,
    RunToolbarCodeSearchDialogComponent
  ],
  imports: [
    CommonModule,
    ToolbarModule,
    IconButtonComponent,
    Q9HtmlDecoderPipe,
    PrimaryButtonComponent,
    ReportsModule,
    SectionComponent,
    SupportButtonComponent,
    ThemeSwitcherComponent,
    SidebarWrapperModule,
    SharedModule,
    NotificationsModule,
    Q9TrackDirective,
    RouterOutlet,
    GridModule,
    OrgNodeSidebarModule,
    DialogCloseButtonComponent,
    NodeSearchComponent,
    InfoMessageComponent,
    GridFilterOperatorSelectComponent,
    ToolbarModule,
    SecondaryButtonComponent,
    SelectModule,
    TextFieldComponent,
    InternalSidebarModule,
    BlurWrapperComponent
  ],
  exports: [CodeSearchComponent, RunCodeSearchDialogComponent]
})
export class CodeSearchModule {}
